import { useSelected, useFocused } from 'slate-react';
import Link from 'next/link';
import { HIDDEN_USERNAME } from 'src/constants/hiddenUser';

// render a mention in the editor
export default function Mention({ attributes, children, element }) {
  const selected = useSelected();
  const focused = useFocused();
  const username = element.mentionedUser?.username || '';

  const onClick = (e) => {
    if (username !== HIDDEN_USERNAME) return;
    else {
      e.preventDefault();
      window.HelpScoutBeacon.triggerHelpScoutArticle('173-what-are-hidden-accounts');
    }
  };

  return (
    <Link
      as={`/user/${username}`}
      href={`/user/profile?username=${username}`}
      {...attributes}
      contentEditable={false}
      data-testid={`mention-${username.replace(' ', '-')}`}
      style={{
        padding: '3px 3px 2px',
        margin: '0 1px',
        cursor: 'pointer',
        verticalAlign: 'baseline',
        display: 'inline-block',
        borderRadius: '4px',
        backgroundColor: '#eee',
        fontSize: '0.9em',
        boxShadow: selected && focused ? '0 0 0 2px #B4D5FF' : 'none',
      }}
      onClick={onClick}
    >
      @{username}
      {children}
    </Link>
  );
}
